import { ParamValues } from '../../../../components/Crud/useFilter.types';
import { saleItemIsKit, saleItemIsProductColor } from '../../../catalogs/utils/saleItemType.utils';
import {
  OfflineDatabaseCatalogSection,
  OfflineDatabaseCatalogSectionItem,
} from '../../database/offlineDatabase/types/offlineDatabaseCatalog.types';
import { GetSectionsWithAvailableProductsOutput } from '../types/getCatalogSections.utils.types';
import CatalogItemsFilterUtils from './catalogProductsFilter.utils';

class GetCatalogSectionsUtils {
  static async getSectionsWithAvailableProducts(
    catalogSections: OfflineDatabaseCatalogSection[],
    params: ParamValues,
  ): Promise<GetSectionsWithAvailableProductsOutput> {
    const availableProductColorSet = await this.getFilteredProductColorSet(catalogSections, params);
    const availableKitSet = await this.getFilteredKitSet(catalogSections, params);

    const offlineSectionProductSet = new Set<string>();
    const sections: OfflineDatabaseCatalogSection[] = [];

    catalogSections.forEach((section) => {
      const availableSectionItems: OfflineDatabaseCatalogSectionItem[] = [];

      section.items.forEach((sectionItem) => {
        const isProductColorAvailableToList =
          saleItemIsProductColor(sectionItem) &&
          availableProductColorSet.has(sectionItem.productColor?.id);

        const isKitAvailableToList =
          saleItemIsKit(sectionItem) && availableKitSet.has(sectionItem.kit?.id);

        if (isProductColorAvailableToList || isKitAvailableToList) {
          availableSectionItems.push(sectionItem);
          offlineSectionProductSet.add(sectionItem.id);
        }
      });

      if (availableSectionItems.length > 0) {
        sections.push({
          ...section,
          items: availableSectionItems,
        });
      }
    });

    return { sections, offlineSectionProductSet };
  }

  private static async getFilteredProductColorSet(
    catalogSections: OfflineDatabaseCatalogSection[],
    params: ParamValues,
  ): Promise<ReadonlySet<string>> {
    const filteredProductColorIds = await CatalogItemsFilterUtils.filterCatalogSectionProducts(
      catalogSections,
      params,
    );
    return new Set(filteredProductColorIds);
  }

  private static async getFilteredKitSet(
    catalogSections: OfflineDatabaseCatalogSection[],
    params: ParamValues,
  ): Promise<ReadonlySet<string>> {
    const filteredKitIds = await CatalogItemsFilterUtils.filterCatalogSectionKits(
      catalogSections,
      params,
    );
    return new Set(filteredKitIds);
  }
}

export default GetCatalogSectionsUtils;
